module.exports = __webpack_public_path__ + "static/logo-lai-tkd-2x-01d7e4018482cfd874938b5ed728b866.png";